import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Col, Row, Card, Badge, Breadcrumb, Table, CardBody } from "react-bootstrap";
import axios from "axios";
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import { Timeline } from 'primereact/timeline';
import { Avatar } from "primereact/avatar";
import { FiCopy } from "react-icons/fi";
import { Tooltip } from 'primereact/tooltip';
import '../../assets/css/dashboard.css';
import '../../assets/css/projects.css';
import noUserImg from '../../assets/images/no_user.png'; // Placeholder for missing profile images
import { AvatarGroup } from 'primereact/avatargroup';
import { OverlayPanel } from 'primereact/overlaypanel';
import { TbFlag3Filled } from "react-icons/tb";
import { FaSkullCrossbones } from "react-icons/fa";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { Button } from 'primereact/button';
import { getSocket } from '../../context/socket'; // adjust path as needed

const Project_details = () => {
    const { accessToken } = useAuth(); // Access token from context
    const socket = getSocket();
    const { project_id } = useParams(); // Get project_id from route params
    const [meetings, setMeetings] = useState([]);
    const navigate = useNavigate(); // React Router's navigate hook
    const [project, setProject] = useState(null); // State to store project details
    const [loading, setLoading] = useState(true); // Loading state
    const [showMore, setShowMore] = useState(false);
    const [error, setError] = useState(null); // Error state
    const op = useRef(null);
    const [showDetails, setShowDetails] = useState(true);

    const [expandedIndices, setExpandedIndices] = useState([]);
    const [expandedCards, setExpandedCards] = useState(new Set());
    const toggleExpanded = (index) => {
        setExpandedIndices(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const [cards, setCards] = useState([]);
    const [listCounts, setListCounts] = useState([]);



    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("month"),
        endDate: moment().endOf("month"),
    });

    const [fillActive, setFillActive] = useState('tab1');
    const [tasks, setTasks] = useState({
        todoTasks: [],
        inProgressTasks: [],
        inReviewTasks: [],
        inChangesTasks: [],
        completedTasks: []
    });
    const [taskCountByStatus, setTaskCountByStatus] = useState([]);

    useEffect(() => {
        // Function to fetch tasks based on project_id
        const fetchTasks = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetch-project-all-tasks?project_id=${project_id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });

                const { tasks, taskCountByStatus } = response.data;

                // Categorize tasks by status
                const todoTasks = tasks.filter(task => task.status === 'Todo');
                const inProgressTasks = tasks.filter(task => task.status === 'InProgress');
                const inReviewTasks = tasks.filter(task => task.status === 'InReview');
                const inChangesTasks = tasks.filter(task => task.status === 'InChanges');
                const completedTasks = tasks.filter(task => task.status === 'Completed');

                // Set the tasks and task counts in state
                setTasks({
                    todoTasks,
                    inProgressTasks,
                    inReviewTasks,
                    inChangesTasks,
                    completedTasks
                });

                setTaskCountByStatus(taskCountByStatus);
            } catch (error) {
                console.error("Error fetching tasks:", error);
            }
        };

        fetchTasks();
    }, [accessToken, project_id]);

    useEffect(() => {
        if (!project_id) return;

        const fetchProjectDetails = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `${config.apiBASEURL}/projectRoutes/projects/${project_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                const fetchedProject = response.data.project;
                setProject(fetchedProject);

                // Once project and board are available, emit socket event
                const boardId = fetchedProject.boards?.[0]?.board_id;
                if (boardId) {
                    socket.emit('fetchBoardCards', { board_id: boardId });
                }

            } catch (err) {
                setError("Failed to fetch project details");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchProjectDetails();

        // Listener for socket response
        socket.on('projectCardData', ({ cards, listCardCounts, error }) => {
            if (!error) {
                setCards(cards);
                setListCounts(listCardCounts);
            } else {
                console.error('Error receiving card data');
            }
        });

        // Cleanup on unmount
        return () => {
            socket.off('projectCardData');
        };

    }, [project_id, accessToken]);

    const unassignedCardCount = useMemo(
        () =>
            cards.filter((c) => {
                if ((c.members || []).length > 0) return false;
                const listName = String(c.list?.name || '')
                    .toLowerCase()
                    .replace(/[\s_-]+/g, '');
                return !['completed', 'done'].includes(listName);
            }).length,
        [cards]
    );

    useEffect(() => {
        if (!project_id || !socket) return;

        // Emit to request meetings
        socket.emit('getMeetingsByProject', { project_id });

        // Listener for response
        socket.on('meetingsByProjectData', ({ project_id: pid, meetings }) => {
            if (pid === project_id) {
                setMeetings(meetings);
            }
        });

        // Clean up the listener
        return () => {
            socket.off('meetingsByProjectData');
        };
    }, [project_id, socket]);




    if (loading) {
        return <p>Loading project details...</p>;
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!project) {
        return <p>No project data found</p>;
    }

    const getBadgeColor = (priority) => {
        switch (priority) {
            case 'High':
                return 'danger'; // Red for high priority
            case 'Medium':
                return 'warning'; // Yellow for medium priority
            case 'Low':
                return 'success'; // Green for low priority
            default:
                return 'secondary'; // Grey for unknown or "N/A"
        }
    };

    /*-------------div show hide-----------*/

    const toggleMore = (cardId) => {
        const newSet = new Set(expandedCards);
        if (newSet.has(cardId)) {
            newSet.delete(cardId);
        } else {
            newSet.add(cardId);
        }
        setExpandedCards(newSet);
    };




    const formatDate = (dateString) => {
        if (!dateString) return '';
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };



    return (
        <Row className="body_content">
            <Row className="mx-0">
                <Col md={6} lg={6} className="mb-4">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
                            <i className="pi pi-angle-left"></i> Back
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Project Details</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col md={6} lg={6} className="mb-4 d-flex justify-content-end align-items-center gap-2">
                    <h6 className="mb-0">Leader : </h6>
                    <div>
                        <ul className="list-unstyled d-flex flex-wrap align-items-center m-0">
                            <li>
                                <img
                                    src={project.lead?.profileImage?.image_url || noUserImg}
                                    alt="Lead Profile"
                                    className="rounded-circle leader-tooltip"
                                    width="30"
                                    height="30"
                                    data-pr-tooltip={`${project.lead?.first_name || ""} ${project.lead?.last_name || ""}`.trim()}
                                    data-pr-position="left"
                                />
                            </li>
                            <Tooltip target=".leader-tooltip" mouseTrack mouseTrackLeft={10} mouseTrackTop={10} />
                        </ul>
                    </div>
                </Col>
                <Col md={12} lg={8}>
                    <Card className='mb-3 h-auto sticky-top' style={{ top: '-35px', zIndex: '100' }}>
                        <Card.Header className='h5'>
                            <div className="d-flex justify-content-between align-items-center">
                                <h6 className="pt-2">
                                    <small className="text-secondary">Brand Name : </small>{project.brand?.brand_name || "N/A"}
                                </h6>
                                {project.boards?.[0]?.board_id && (
                                    <Button
                                        label='Go to Board'
                                        icon='pi pi-arrow-right'
                                        className='border-0 py-2'
                                        severity="warning"
                                        iconPos="right"
                                        onClick={() => navigate(`/Graphe/dashboard/kanbanboard/${project.boards[0].board_id}`)}

                                    />
                                )}

                            </div>

                            <Table size="sm" borderless className="mb-0 mt-4 prodetTable">
                                <thead>
                                    <tr>
                                        <td>Project Name</td>
                                        <td>Created</td>
                                        <td>Deadline</td>
                                        <td>Priority</td>
                                        <td>Status</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>{project.project_name || "N/A"}</th>
                                        <th className='text-info'>
                                            {project.start_date ? new Date(project.start_date).toLocaleDateString('en-GB') : "N/A"}
                                        </th>
                                        <th className='text-danger'>
                                            {project.end_date ? new Date(project.end_date).toLocaleDateString('en-GB') : "N/A"}
                                        </th>

                                        <th>
                                            <Badge className={`bg-${getBadgeColor(project.priority)}`}>
                                                {project.priority || "N/A"}
                                            </Badge>
                                        </th>
                                        <th>{project.status || "N/A"}</th>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Header>
                        <Card.Body>
                            {project.description || "No description available"}
                        </Card.Body>
                    </Card>

                    <Row className="mx-0">
                        <Col md={6} lg={7} className="ps-lg-0 mb-3">
                            <Card className='h-100'>
                                <Card.Header className='h5'>Uploaded Files Drive Link</Card.Header>
                                <Card.Body>
                                    <ul className='fileupload_card'>
                                        <li>
                                            <div className='d-flex align-items-center'>
                                                <div className='filecoppy_ic mt-1'>
                                                    <FiCopy className='text-secondary' />
                                                </div>
                                                <div className='ms-3'>

                                                    <p className='fw-bold mb-1'>
                                                        {project.project_files ? (
                                                            <span
                                                                className='text-black text-break'
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {project.project_files}
                                                            </span>
                                                        ) : (
                                                            'No files uploaded'
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} lg={5} className="pe-lg-0 mb-3">
                            <Card className='h-100'>
                                <Card.Header className='h5'>Assigned Team Members</Card.Header>
                                <Card.Body>
                                    <Tooltip target=".member-tooltip" mouseTrack mouseTrackLeft={10} mouseTrackTop={10} />
                                    <ul className="list-unstyled m-0 d-flex flex-wrap align-items-center gap-3">
                                        {project.members?.length ? (
                                            project.members.map((member) => (
                                                <li key={member.user_id} className="d-flex align-items-center me-3 mt-2 member-tooltip">
                                                    <img
                                                        src={member.profileImage?.image_url || noUserImg}
                                                        alt="Member Profile"
                                                        className="rounded-circle me-2"
                                                        width="25"
                                                        height="25"
                                                    />
                                                    <span style={{ fontSize: '13px' }}>{`${member.first_name || ""} ${member.last_name || ""}`.trim()}</span>
                                                </li>
                                            ))
                                        ) : (
                                            <p>No team members assigned</p>
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Card className='h-auto p-0 ps-2 mb-2'>
                        <Card.Header className='h5 d-flex justify-content-between align-items-center'>
                            <div>
                                Client Submitted Form Details
                                <Badge className="ms-2 bg-danger">
                                    {project.acceptedProjects?.[0]?.formSubmission?.form_name}
                                </Badge>
                            </div>
                            {project.acceptedProjects?.[0]?.formSubmission?.formDataEntries?.length > 0 && (
                                <Button
                                    icon={showDetails ? 'pi pi-eye-slash' : 'pi pi-eye'}
                                    outlined
                                    className="border-0"
                                    severity="danger"
                                    onClick={() => setShowDetails(prev => !prev)}
                                />
                            )}

                        </Card.Header>

                        <Card.Body>
                            {showDetails && project.acceptedProjects?.[0]?.formSubmission?.formDataEntries?.length > 0 && (
                                <div className="p-2">
                                    {(() => {
                                        const formData = project.acceptedProjects?.[0]?.formSubmission?.formDataEntries || [];

                                        // Group by step and section_name
                                        const groupedByStep = formData.reduce((acc, entry) => {
                                            const stepKey = `${entry.step}`;
                                            if (!acc[stepKey]) acc[stepKey] = {};
                                            const sectionKey = entry.section_name;
                                            if (!acc[stepKey][sectionKey]) acc[stepKey][sectionKey] = [];
                                            acc[stepKey][sectionKey].push(entry);
                                            return acc;
                                        }, {});

                                        return Object.entries(groupedByStep).map(([step, sections]) => (
                                            <div key={step} className="mb-0">
                                                {Object.entries(sections).map(([section, fields]) => (
                                                    <div key={section} className="allempList mt-3">
                                                        <h6 className="rol-title">{section}</h6>
                                                        <ul>
                                                            {fields.map((field, i) => (
                                                                <li key={i}>
                                                                    <small className="text-danger d-block">{field.field_label}:</small>{" "}
                                                                    {field.input_type === "date"
                                                                        ? new Date(field.response).toLocaleDateString("en-GB")
                                                                        : field.response}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        ));
                                    })()}
                                </div>
                            )}
                        </Card.Body>
                    </Card>



                    <Card className='h-auto p-0 ps-2'>
                        <Card.Header className='h5'>
                            Project Meetings
                            <Badge className="ms-2 bg-danger">{meetings.length}</Badge>
                        </Card.Header>
                        <Card.Body className="prosec_meet">
                            <ul>
                                {meetings.length === 0 ? (
                                    <p className="text-muted ps-3">No meetings found.</p>
                                ) : (
                                    meetings.map((meeting, index) => (
                                        <li key={meeting.id || index}>
                                            <div>
                                                <h6 className="mb-3 ps-4">
                                                    {meeting.meeting_title || 'Meeting Title'}
                                                    <Badge className={`ms-2 ${meeting.type === 'Internal' ? 'bg-warning' : 'bg-success'}`} style={{ position: 'absolute', top: '0', right: '0' }}>
                                                        {meeting.type || 'External'}
                                                    </Badge>
                                                </h6>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <p>
                                                        <span className="d-block">Date</span>
                                                        {new Date(meeting.date).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        })}

                                                    </p>
                                                    <p>
                                                        <span className="d-block">Members</span>
                                                        {meeting.meeting_members || 'N/A'}
                                                    </p>
                                                    <p>
                                                        <span className="d-block">Created By</span>
                                                        <img
                                                            src={meeting.creator?.profileImage?.image_url || noUserImg}
                                                            alt="Creator"
                                                            className="rounded-circle leader-tooltip"
                                                            width="25"
                                                            height="25"
                                                            data-pr-tooltip={`${meeting.creator?.first_name || ''} ${meeting.creator?.last_name || ''}`.trim()}
                                                            data-pr-position="left"
                                                        />
                                                        <Tooltip target=".leader-tooltip" mouseTrack mouseTrackLeft={10} mouseTrackTop={10} />
                                                    </p>
                                                    <p>
                                                        <Link
                                                            to="#"
                                                            className="text-purple d-flex align-items-center"
                                                            onClick={() => toggleExpanded(index)}
                                                        >
                                                            {expandedIndices.includes(index) ? "View Less" : "View More"}
                                                            <i className={`pi ${expandedIndices.includes(index) ? 'pi-chevron-up' : 'pi-chevron-down'} ps-2`}></i>
                                                        </Link>
                                                    </p>
                                                </div>
                                            </div>
                                            {expandedIndices.includes(index) && (
                                                <div className="moremt_det">
                                                    {['agenda', 'action_items', 'discussions', 'decisions', 'client_updates'].map((key) => (
                                                        <div className="mb-2" key={key}>
                                                            <h6>{key.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}</h6>
                                                            <span>{meeting[key] || 'N/A'}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </li>
                                    ))
                                )}
                            </ul>
                        </Card.Body>
                    </Card>


                </Col>

                <Col md={12} lg={4} style={{ height: 'fit-content' }} className="sticky-top">
                    <Card className="timeCard ">
                        <Card.Header className='h6 d-flex justify-content-between align-items-center'>
                            <h6 className="mb-0 p-overlay-badge position-relative">
                                Timeline
                                <Badge value="3" className="ms-2 bg-danger">0</Badge>
                            </h6>

                        </Card.Header>
                        <CardBody className="px-3 pt-0">
                            {unassignedCardCount > 0 && (
                                <div className="alert alert-warning py-2 small mb-3">
                                    <strong>
                                        {unassignedCardCount} unassigned task
                                        {unassignedCardCount === 1 ? '' : 's'}
                                    </strong>
                                    {' '}— open the board and assign someone before work can move forward.
                                    {project?.boards?.[0]?.board_id && (
                                        <>
                                            {' '}
                                            <Link
                                                to={`/Graphe/dashboard/kanbanboard/${project.boards[0].board_id}`}
                                            >
                                                Open board
                                            </Link>
                                        </>
                                    )}
                                </div>
                            )}
                            <div className="d-flex flex-wrap justify-content-between align-items-center text-center bg-light py-2 px-3 mb-3 gap-3">
                                {listCounts.map((list) => (
                                    <span key={list.list_id} style={{ color: list.color_code || '#4a00e5' }}>
                                        <small className="d-block">{list.list_name}</small>
                                        <b>{list.card_count}</b>
                                    </span>
                                ))}
                            </div>


                            <ul className="pjtask_time">
                                {cards.map((card, idx) => {
                                    const isExpanded = expandedCards.has(card.card_id);

                                    return (
                                        <li key={card.card_id || idx}>
                                            <p><small>Task Name</small>: <span>{card.title}</span></p>

                                            <p>
                                                <small>Status</small>:
                                                <span
                                                    style={{
                                                        fontSize: '12px',
                                                        backgroundColor: card.list?.color_code || '#ccc',
                                                        color: '#fff',
                                                        padding: '0px 5px',
                                                        borderRadius: '4px',
                                                        display: 'inline-block',
                                                        width: 'fit-content'
                                                    }}
                                                >
                                                    {card.list?.name}
                                                </span>
                                            </p>

                                            <p>
                                                <small>Deadline</small>:
                                                <span className="text-danger">{formatDate(card.due_date)}</span>
                                            </p>

                                            <p>
                                                <small>Assigned To</small>:
                                                <span>
                                                    {(card?.members || []).length > 0 ? (
                                                    <AvatarGroup>
                                                        {card.members.map((member) => {
                                                            const fullName = `${member.first_name} ${member.last_name}`;

                                                            return (
                                                                <React.Fragment key={member.id || member.user_id}>
                                                                    <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                                                    <Avatar
                                                                        id={`avatar-${member.user_id}`}
                                                                        image={member?.profileImage?.image_url || 'https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png'}
                                                                        shape="circle"
                                                                        title={fullName}
                                                                    />
                                                                </React.Fragment>
                                                            );
                                                        })}
                                                    </AvatarGroup>
                                                    ) : (
                                                        <Badge bg="warning" text="dark" className="ms-1">
                                                            Unassigned
                                                        </Badge>
                                                    )}
                                                </span>
                                            </p>

                                            <p className="justify-content-between">
                                                <Link to="" onClick={() => toggleMore(card.card_id)} className="text-info">
                                                    {isExpanded ? 'Less...' : 'More...'}
                                                </Link>
                                                <i className="text-danger">
                                                    {card.priority === "Urgent" && <TbFlag3Filled />} &nbsp;
                                                    {card.missed_deadline && <FaSkullCrossbones />}
                                                </i>

                                            </p>

                                            <div className={`moredetails timeline-card ${isExpanded ? 'show' : ''}`} style={{ overflowY: 'auto' }}>
                                                <Timeline
                                                    value={card.activities}
                                                    content={(activity) => (
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <Avatar
                                                                image={activity.user_details?.profileImage?.image_url || noUserImg}
                                                                shape="circle"
                                                                className="me-2"
                                                                style={{ width: '30px', height: '30px' }}
                                                            />
                                                            <small>
                                                                {formatDate(activity.created_date)}
                                                                <br />
                                                                <small className="text-warning">{activity.activity}</small>
                                                            </small>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>

                        </CardBody>
                        {/* <Card className='mb-3 h-auto'>
                            <Card.Header className='h5'>Assigned Leader</Card.Header>
                            <Card.Body>
                                <Tooltip target=".leader-tooltip" mouseTrack mouseTrackLeft={10} mouseTrackTop={10} />
                                <ul className="list-unstyled d-flex flex-wrap align-items-center m-0">
                                    <li className="d-flex align-items-center me-3 mt-2 leader-tooltip">
                                        <img
                                            src={project.lead?.profileImage?.image_url || noUserImg}
                                            alt="Lead Profile"
                                            className="rounded-circle me-2"
                                            width="30"
                                            height="30"
                                        />
                                        <span>{`${project.lead?.first_name || ""} ${project.lead?.last_name || ""}`.trim()}</span>
                                    </li>
                                </ul>
                            </Card.Body>
                        </Card> 
                        <Card className='mb-3 h-auto'>
                            <Card.Header className='h5'>Assigned Team Members</Card.Header>
                            <Card.Body>
                                <Tooltip target=".member-tooltip" mouseTrack mouseTrackLeft={10} mouseTrackTop={10} />
                                <ul className="list-unstyled m-0">
                                    {project.members?.length ? (
                                        project.members.map((member) => (
                                            <li key={member.user_id} className="d-flex align-items-center me-3 mt-2 member-tooltip">
                                                <img
                                                    src={member.profileImage?.image_url || noUserImg}
                                                    alt="Member Profile"
                                                    className="rounded-circle me-2"
                                                    width="25"
                                                    height="25"
                                                />
                                                <span style={{ fontSize: '13px' }}>{`${member.first_name || ""} ${member.last_name || ""}`.trim()}</span>
                                            </li>
                                        ))
                                    ) : (
                                        <p>No team members assigned</p>
                                    )}
                                </ul>
                            </Card.Body>
                        </Card>*/}
                    </Card>
                </Col>

            </Row>
        </Row >
    );
};

export default Project_details;
